import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchCategories } from "../store/slices/categorySlice";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { logout } from '../store/slices/userSlice';
import { fetchSearchResults, updateSearchField } from "../store/slices/searchSlice";

const Footer = () => {
    const dispatch = useDispatch();
    const location=useLocation()
    const navigate=useNavigate()
    const { categories, status } = useSelector((state) => state.categories);
    const { isAuthenticated, user } = useSelector((state) => state.user);

    const handleLogout = () => {
        dispatch(logout());
    };
    useEffect(() => {
        window.scrollTo(0, 0);
      }, [location.pathname]);
     const handleCategorySet = (subCategory) => {
            // Mettre à jour la valeur de `query` avec le nom de la sous-catégorie
            dispatch(updateSearchField({ field: 'query', value: subCategory.name }));
            const searchData = {
                categoryId: subCategory.id || null,
                filtre: [],
                disponibilite:'all-time',
                when: "all_time",
                sortBy: "relevance",
                search_query:subCategory.name,
                query:subCategory.name
              };
            // Mettre à jour la valeur de `categoryId` avec l'ID de la sous-catégorie
            dispatch(updateSearchField({ field: 'categoryId', value: subCategory.id }));
                    dispatch(fetchSearchResults(searchData));
            
            navigate("/resultats", { replace: true });
        };
    useEffect(() => {
        if (status === "idle") {
            dispatch(fetchCategories());
        }
    }, [status, dispatch]);

    return (
        <footer className="footer">
            <div className="container">
                <div className="row">
                    <div className="footer-sections">
                        <div className="footer-logo text-start">
                           <a className="link-blue" href="/"><img src="/images/LogotwynyFooter.svg" alt="Logo" className="logo" /></a> 
                            <p className="body mt-24">La plateforme pour <br />prendre rendez-vous avec <br />tout type de prestataire, <br />à prix fixe</p>
                        </div>
                        <div className="footer-section">
                            </div>
                        <div className="footer-section">
                            <h5 className="text-white mb-0">Services</h5>
                            <ul className="mt-16">
                                {categories.slice(0, 5).map((category) => (
                                    <li key={category.id}>
                                        <span onClick={()=>{handleCategorySet(category)}}
                                       // to={`/category/${category.id}`} 
                                        className="body pointer">{category.name}
                                        </span>
                                        </li>
                                ))}
                            </ul>
                        </div>

                        <div className="footer-section">
                            <h5 className="text-white mb-0">Aide</h5>
                            <ul className="mt-16">
                                <li><a href="/tous-faq" className="body">FAQ</a></li>
                                <li><a href="/login" className="body">Demande de <br />remboursement</a></li>
                                <li><a href="mailto:support@twyny.com" className="body">Contact</a></li>
                                <li><a href="/blog" className="body">Blog</a></li>
                            </ul>
                        </div>

                        <div className="footer-section">
                            <h5 className="text-white mb-0">Légal</h5>
                            <ul className="mt-16">
                                <li><a href="/mentions-legales" className="body">Mentions légales</a></li>
                                <li><a href="/cgu" className="body">CGU</a></li>
                                <li><a href="/cgv" className="body">CGV</a></li>
                                <li><a href="/politique-confidentialite" className="body">Politique de confidentialité</a></li>
                                <li><a href="/Politique-de-lutte-contre-les-contenus-illicites" className="body text-wrap">Politique de lutte contre les contenus illicites</a></li>
                            </ul>
                        </div>
                    </div>


                    <hr className="footer-separator" />

                    <div className="footer-bottom">
                        <div className="footer-social">
                            <a href="https://www.linkedin.com/company/twyny/" target="_blank" rel="noopener noreferrer">
                            <img src="/images/linkedin.svg" alt="linkedin icon" />
                            </a>
                            <a href="https://www.instagram.com/twyny_marketplace/" target="_blank" rel="noopener noreferrer">
                            <img src="/images/insta.svg" alt="linkedin icon" />
                            </a>
                            <a href="https://www.facebook.com/twynymarketplace" target="_blank" rel="noopener noreferrer">
                            <img src="/images/fcb.svg" alt="linkedin icon" />
                            </a>
                        </div>

                        <div className="text-start">
                         
                                    <Link to="/register" className='twyny-cta-list m-0 mr-8'>
                                        <button className="btn twyny-cta-secondary mt-xs-8">S’inscrire</button>
                                    </Link>

                                    <Link to="/registerPrestataire" className='twyny-cta-list m-0'>
                                        <button className="btn twyny-cta-primary mt-xs-8">Devenir partenaire</button>
                                    </Link>
                              
                        </div>
                    </div>
                </div>
            </div>

        </footer>
    );
};

export default Footer;
